<div class="field" [ngStyle]="{'padding-bottom': (hasAlert) ? '15px' : '0px'}">
  <!-- State type dimension -->
  @if (isState) {
    <label [attr.for]="id" soho-label>{{dimension.label}}</label>
    <select
      soho-dropdown
      [ngClass]="'dropdown-md'"
      [attr.id]="id"
      [attributes]="dropdownAttributes"
      [(ngModel)]="dimension.value"
      >
      <option [value]="''">{{''}}</option>
      @for (option of dimension.states; track option) {
        <option [value]="option.value">{{option.label}}</option>
      }
    </select>
  }

  <!-- Boolean type dimension -->
  @if (isBoolean) {
    <label [attr.for]="id" soho-label>{{dimension.label}}</label>
    <select
      soho-dropdown
      [ngClass]="'dropdown-md'"
      [attr.id]="id"
      [attributes]="dropdownAttributes"
      [(ngModel)]="dimension.value"
      >
      <option [value]="''">{{''}}</option>
      <option [value]="'true'">{{'Yes' | translate}}</option>
      <option [value]="'false'">{{'No' | translate}}</option>
    </select>
  }

  <!-- Period dimension -->
  @if (isPeriod) {
    <lm-cube-period-dimension
      [attr.data-automation-id]="fieldAutomationId"
      [dimension]="dimension"
      >
    </lm-cube-period-dimension>
  }

  <!-- Key field dimension -->

  @if (isKeyField) {
    <lm-lookup-basic
      [attr.data-automation-id]="fieldAutomationId"
      [cubeBusClass]="cubeBusClass"
      [cubeDimension]="dimension"
      [selectListUrl]="selectListUrl"
      [cubeGetFieldsUrl]="getFieldsUrl"
      [showAlert]="structures && hasReportingBasis"
      [topNodeBaseValue]="topNodeBaseValue"
      (lookupValueChangedEvent)="fieldValueChanged($event)"
      >
    </lm-lookup-basic>
  }

  <!-- Other dimension -->
  @if (isText) {
    <label [attr.for]="id" soho-label>{{dimension.label}}</label>
    <input
      soho-input
      [attr.id]="id"
      [(ngModel)]="dimension.value"
      />
    }
  </div>
